import { Reveal, SectionHeader } from "@/components/site/Reveal";
import { TECHNOLOGIES } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export const Technologies = () => {
    const { t } = useLanguage();

    return (
        <section id="technologies" className="relative py-24 md:py-32 bg-surface/40" data-testid="technologies-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <SectionHeader
                    number={t.technologies.number}
                    label={t.technologies.label}
                    title={t.technologies.title}
                    description={t.technologies.description}
                />
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
                    {TECHNOLOGIES.map((tech, i) => (
                        <Reveal key={tech.name} delay={(i % 5) * 0.06}>
                            <div
                                className="group glass-card glass-card-hover rounded-xl px-4 py-4 flex items-center gap-3 transition-transform duration-300 hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(0,210,255,0.1)]"
                                data-testid={`tech-card-${tech.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            >
                                <tech.icon
                                    className="h-5 w-5 shrink-0 text-zinc-500 transition-all duration-300 group-hover:text-cyan-400 group-hover:scale-125"
                                    strokeWidth={1.5}
                                />
                                <span className="font-mono text-xs md:text-sm text-zinc-300 transition-colors duration-300 group-hover:text-white">
                                    {tech.name}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
